import type { Project } from "~/models";
import activities from "./activities";
import budgetTypes from "./budgetTypes";
import currencies from "./currencies";
import resourceStatuses from "./resourceStatuses";
import statuses from "./statuses";
import users from "./users";

const projects: Project[] = [
    {
        id: "1",
        code: "COCA-0001",
        name: "Coca Cola Christmas campaign",
        posted: new Date("2023-01-12"),
        country: "US",
        group: "01",
        cm: users[4],
        start: new Date("2023-01-01"),
        end: new Date("2023-06-01"),
        pm: users[4],
        contact: "Linus Newman",
        client: "Excellent education Inc.",
        documents: [
            {
                id: "1",
                name: "api_specification_for_lorem_integration.pdf",
                owner: users[0],
            },
            {
                id: "2",
                name: "result_report.xlsx",
                owner: users[0],
            },
        ],
        invoices: [
            {
                id: "1",
                name: "First invoice",
                amount: 20000,
                reference: "Some ref",
                creator: users[0],
            },
            {
                id: "2",
                name: "Second invoice",
                amount: 50000,
                reference: "Another ref",
                creator: users[0],
            },
        ],
        budgets: [
            {
                id: "1",
                name: "Test budget",
                currency: currencies[0],
                rate: 50,
                status: "approved",
                phases: [
                    {
                        id: "1",
                        name: "Prepare",
                        defaultRecordType: budgetTypes[0],
                        defaultStartDate: new Date("2023-01-01"),
                        defaultEndDate: new Date("2023-03-01"),
                        records: [
                            {
                                id: "1",
                                user: users[0],
                                activity: activities[0],
                                description: "Prepare domain description",
                                quantity: 60,
                                price: 800,
                                amount: 48000,
                                start: new Date("2023-01-17"),
                                end: new Date("2023-01-31"),
                                type: budgetTypes[1],
                            },
                            {
                                id: "2",
                                user: users[0],
                                activity: activities[0],
                                description: "Think about something",
                                quantity: 40,
                                price: 800,
                                amount: 32000,
                                start: new Date("2023-01-17"),
                                end: new Date("2023-01-31"),
                                type: budgetTypes[1],
                            },
                            {
                                id: "3",
                                user: users[1],
                                activity: activities[0],
                                description: "Buy domain for the application",
                                quantity: 1,
                                price: 35000,
                                costPrice: 35000,
                                amount: 35000,
                                start: new Date("2023-01-17"),
                                end: new Date("2023-01-31"),
                                type: budgetTypes[1],
                            },
                            {
                                id: "4",
                                user: users[2],
                                activity: activities[1],
                                description:
                                    "Prepare mid-term plan how to increase team's delivery",
                                quantity: 1,
                                price: 60000,
                                costPrice: 60000,
                                amount: 60000,
                                start: new Date("2023-01-17"),
                                end: new Date("2023-03-01"),
                                type: budgetTypes[1],
                            },
                        ],
                    },
                    {
                        id: "2",
                        name: "Initiation",
                        defaultRecordType: budgetTypes[0],
                        defaultStartDate: new Date("2023-02-01"),
                        defaultEndDate: new Date("2023-03-15"),
                        records: [
                            {
                                id: "10",
                                user: users[0],
                                activity: activities[0],
                                description: "Setup repository",
                                quantity: 15,
                                price: 350,
                                amount: 5250,
                                start: new Date("2023-01-10"),
                                end: new Date("2023-01-20"),
                                type: budgetTypes[0],
                            },
                        ],
                    },
                    {
                        id: "3",
                        name: "Dashboard",
                        defaultRecordType: budgetTypes[0],
                        defaultStartDate: new Date("2023-03-01"),
                        defaultEndDate: new Date("2023-04-01"),
                        records: [],
                    },
                    {
                        id: "4",
                        name: "Round-off",
                        defaultRecordType: budgetTypes[0],
                        defaultStartDate: new Date("2023-04-01"),
                        defaultEndDate: new Date("2023-06-01"),
                        records: [],
                    },
                ],
            },
        ],
        tasks: [
            {
                id: "1",
                name: "Resource planning",
                description:
                    "Research and provide high-level overview for Resource planning feature",
                logs: [
                    {
                        start: new Date("2023-01-31T14:00:00"),
                        end: new Date("2023-01-31T16:00:00"),
                    },
                ],
                project: {
                    id: "1",
                    name: "Coca Cola Christmas campaign",
                },
                activity: activities[0],
                reporter: users[0],
                assignee: users[1],
                status: statuses[0],
                resourceStatus: resourceStatuses[0],
                attachments: [],
                budgeted: {
                    start: new Date("2023-01-01"),
                    end: new Date("2023-03-15"),
                },
                planned: {
                    start: new Date("2023-02-06"),
                    end: new Date("2023-02-10"),
                },
                estimated: 20,
                adjusted: 20,
                completeness: 10,
            },
        ],
    },
    {
        id: "2",
        code: "TEST-0001",
        name: "Test Empty Project",
        posted: new Date("2023-02-02"),
        country: "UK",
        group: "02",
        cm: users[2],
        start: new Date("2023-03-01"),
        end: new Date("2023-06-01"),
        pm: users[1],
        contact: "Test Contact",
        client: "Test Client",
        documents: [],
        invoices: [],
        budgets: [],
        tasks: [],
    },
];

export default projects;
